import { Component, HostBinding, Input, Output, TemplateRef, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { SdPushCardComponent, SdThemeComponent } from '@seb/web-design-system/core';

import type { IDocument } from './document/document.interface';
import { SdDocumentComponent } from './document/document.component';

@Component({
  selector: 'sd-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdDocumentComponent,
    NgTemplateOutlet
  ]
})
export class SdDocumentsComponent extends SdThemeComponent {
  @Input()
  pushTemplate: TemplateRef<SdPushCardComponent>;

  @Input()
  documents: IDocument[];

  @Input()
  titleLevel: number;

  @Output()
  downloadedDocument = new EventEmitter<IDocument>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      'sdChangeTheme',
      'ds-component is-small-width',
      this.pushTemplate ? 'has-push' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  onDownloadDocument(event: IDocument) {
    this.downloadedDocument.emit(event);
  }
}
